import React, { useEffect, useMemo, useState } from "react";

import { Line, Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import moment from "moment";
import ChartState from "./_shared/ChartState";
import { ACCENT, GRID_COLOR } from "./_shared/chartTheme";

const DiamondReportsClicksComp = ({ data, loading, onChartTypeChange }) => {
  const { t } = useTranslation();
  const [chartType, setChartType] = useState("line");

  // Reports the current Line/Bar selection up to the flagship page so its
  // Download PDF can send it as barViewDimensions - same pattern as
  // DiamondReportsColorComp.js etc. Was missing entirely, so the PDF always
  // rendered this panel as a Line chart no matter what was selected on
  // screen (Task: Click Trends toggle not reflected in PDF, 2026-09-18).
  useEffect(() => { onChartTypeChange?.(chartType); }, [chartType]);

  // Sort chronologically ascending — the API returns them in reverse.
  const sortedList = useMemo(
    () => [...(data || [])].sort((a, b) => moment(a.Date) - moment(b.Date)),
    [data]
  );
  const diamondClicksLabels = sortedList.map((item) => item.Date);
  const DiamondClicksYAxisList = sortedList.map((item) => item.CNT);

  const chartJsData = {
    labels: diamondClicksLabels,
    datasets: [
      {
        label: t("Clicks"),
        data: DiamondClicksYAxisList,
        backgroundColor:
          chartType === "bar" ? ACCENT : "rgba(59, 91, 219, .15)",
        borderColor: ACCENT,
        borderWidth: 2,
        fill: chartType === "line",
        tension: 0.35,
        pointRadius: chartType === "line" ? 2 : 0,
        borderRadius: 3,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      x: { grid: { display: false } },
      y: { grid: { color: GRID_COLOR }, beginAtZero: true },
    },
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <div className="edr-panel-head">
          <label>
            <b> {t("Diamond Clicks")} </b>
          </label>
          <div className="edr-seg">
            <button
              className={chartType === "line" ? "edr-on" : ""}
              onClick={() => setChartType("line")}
            >
              {t("Line")}
            </button>
            <button
              className={chartType === "bar" ? "edr-on" : ""}
              onClick={() => setChartType("bar")}
            >
              {t("Bar")}
            </button>
          </div>
        </div>
        <div className="chart__section">
          {!loading && diamondClicksLabels.length > 0 ? (
            <div className="edr-chartwrap edr-tall">
              {chartType === "line" ? (
                <Line data={chartJsData} options={options} />
              ) : (
                <Bar data={chartJsData} options={options} />
              )}
            </div>
          ) : (
            <ChartState loading={loading} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsClicksComp;
